module.exports = __webpack_public_path__ + "img/rwdt_bg.060c4b69.png";